// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  enabled: process.env.NEXT_PUBLIC_APP_ENV === 'production',
  ignoreErrors: [
    `ReferenceError: Can't find variable: gmo`,
    'Java exception was raised during method invocation',
  ],
  integrations: [
    //We need to disable eslint here because of a bug in eslint(https://github.com/getsentry/sentry-javascript/issues/12706)
    // eslint-disable-next-line import/namespace
    Sentry.replayIntegration({
      // Additional SDK configuration goes in here, for example:
      networkDetailAllowUrls: [/^https:\/\/basket\.emoti\.dev\/api\/v1/],
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.1,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  replaysOnErrorSampleRate: 1.0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,
});

// Required export for navigation instrumentation
// `captureRouterTransitionStart` is available from SDK version 9.12.0 onwards
export const onRouterTransitionStart =
  'captureRouterTransitionStart' in Sentry
    ? Sentry.captureRouterTransitionStart
    : undefined;
